export const KEYS = {
  ALERTS: 'alerts',
  FILTERS: 'filters',
  SEARCH_TERM: 'searchTerm',
  ALERT_STATE: 'alertState',
  SHOW_BADGE: 'showBadge',
};

// Uncomment this to create mock alerts
// function makeMockAlerts(num = 20) {
//   return [...Array(num).keys()].reduce((acc, i) => {
//     const ts = new Date().getTime() + i;
//     acc[ts] = {
//       id: ts,
//       type: 'warning',
//       ts,
//       message:
//       `Alert${i} The are is one default array for some olong text to be checked `,
//     };
//     return acc;
//   }, {});
// }

export default {
  [KEYS.ALERTS]: [], // store alerts as array of AlertModel
  [KEYS.FILTERS]: {}, // alerts filter by type - error/warning/info/...
  [KEYS.SEARCH_TERM]: '', // search input value
  [KEYS.ALERT_STATE]: {}, // state of the last alert { [id]: { showAlert: true/false } }
  [KEYS.SHOW_BADGE]: false, // show alert badge
};

